import React from 'react'
import moment from 'moment'
import { Expose, Transform } from 'class-transformer'

export class Base {
  static Icon?: React.FC

  guid: string = ''
  name: string = ''

  @Expose({ name: 'created_on' })
  @Transform((value) => moment(value))
  createdOn: moment.Moment = moment()

  @Expose({ name: 'updated_on' })
  @Transform((value) => moment(value))
  updatedOn: moment.Moment = moment()
}
